import { render, staticRenderFns } from "./BindChatroomModal.vue?vue&type=template&id=39ef0fcb&scoped=true&"
import script from "./BindChatroomModal.vue?vue&type=script&lang=js&"
export * from "./BindChatroomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ef0fcb",
  null
  
)

export default component.exports